const locale = {
	// #region Marketing Actions fields
	DETAILS_MARKETINGACTIONS_FIELD_TITLE: 'Title',
	DETAILS_MARKETINGACTIONS_FIELD_STATUS: 'Marketing Action Status',
	DETAILS_MARKETINGACTIONS_FIELD_TYPE: 'Marketing Action Type',
	DETAILS_MARKETINGACTIONS_FIELD_ASSIGNED_USER: 'Internal assigned User',
	DETAILS_MARKETINGACTIONS_FIELD_ASSIGNED_USER_2: 'External assigned User',
	DETAILS_MARKETINGACTIONS_FIELD_DATE_FROM: 'Start date',
	DETAILS_MARKETINGACTIONS_FIELD_DATE_TO: 'End date',
	DETAILS_MARKETINGACTIONS_FIELD_PROGRESS: 'Progress',
	DETAILS_MARKETINGACTIONS_FIELD_WARNING: 'Warning',
	DETAILS_MARKETINGACTIONS_FIELD_BLOCKED: 'Blocked',
	DETAILS_MARKETINGACTIONS_FIELD_TAGS: 'Tags',
	DETAILS_MARKETINGACTIONS_FIELD_EXPENSES: 'Expenses',
	// #endregion

	// #region Marketing Actions details right sidebar
	MARKETINGACTIONS_STATS_SECTION: 'Statistics',
	MAAC_STATISTICS_VALUE_EXPENSES: 'Expenses',
	MAAC_STATISTICS_VALUE_PLANNED: 'Opportunity value',
	MAAC_STATISTICS_N_OPPORTUNITIES: 'N° Opportunities',
	MAAC_STATISTICS_N_LEADS: 'N. Leads',
	MAAC_STATISTICS_N_CUSTOMERS: 'N. Customers',
	MAAC_STATISTICS_LEAD_CONVERSION: 'Lead Conversion Rate',
	MAAC_STATISTICS_CAC: 'Customer Acquisition Cost (CAC)',
	MAAC_STATISTICS_CPA: 'Cost per Action (CPA)',
	// #endregion

	// #region Details MarketingAction Add Rows section
	MAAC_SECTION_ADD_TITLE: 'Add to list',
	MAAC_SECTION_ADD_DESCRIPTION_COMPANIES:
		"Add a new or existing Company who partecipated in this Marketing Action (if it doesn't exist will be automatically added to the database and it will be available for use in any recall action).",
	MAAC_SECTION_ADD_DESCRIPTION_PEOPLE:
		"Add a new or existing Person who partecipated in this Marketing Action (if it doesn't exist will be automatically added to the database and it will be available for use in any recall action).",

	MAAC_SECTION_ADD_COMPANIES_TITLE: 'Add filtered Companies',
	MAAC_SECTION_ADD_PEOPLE_TITLE: 'Add filtered People',

	MAAC_SECTION_COPY_TITLE: 'Import from',
	MAAC_SECTION_COPY_MARKETINGACTION: 'Marketing Action',
	MAAC_SECTION_COPY_DEM: 'DEM',
	MAAC_SECTION_COPY_COMMERCIALCAMPAIGN: 'Commercial Campaign',

	MAAC_DIALOG_TITLE_ADD_RESULT: 'Do you want to add those elements?',
	// #endregion

	// #region Details MarketingAction Delete Rows section
	MAAC_SECTION_EMPTY_TITLE: 'Clear the list',
	MAAC_SECTION_EMPTY_DESCRIPTION: 'With this function you can clear the list (removing ALL the added elements)',
	MAAC_SECTION_EMPTY_BUTTON_CLEAR: 'Clear'
	// #endregion
};

export default locale;
